import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const BoxListItem = styled.div`
  ${() => css`
    width: '100%';
    height: 70px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #235f6e;

    div.indicador {
      width: 500px;
      padding-left: 30px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      span {
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.15;
        letter-spacing: 0.46px;
        color: #235f6e;
        font-size: 13px;
      }

      button {
        background-color: transparent;
        border: none;
      }
    }
    div.coleta {
      width: 150px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: 0.01px;
      color: #999999;
    }
    div.status {
      width: 220px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      > span {
        color: #74a50a;
        font-size: 13px;
      }
    }
  `}
`;

export const ButtonStatus = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background-color: #74a50a;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  svg {
    color: #fff;
  }
`;

export const ButtonList = styled.div`
  ${({ isOpen }) => css`
    width: 21px;
    height: 21px;
    border-radius: 3px;
    border: solid 0.5px ${isOpen ? '#4c7c88 ' : '#d8d8d8'};
    background-color: ${isOpen ? '#235f6e' : '#FFF'};
    margin-right: 20px;
    svg {
      color: ${isOpen ? '#FFF' : '#999999'};
    }
  `}
`;

export const BoxButtonList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const BoxIndicators = styled.div`
  ${() => css`
    padding: 10px 30px 20px 30px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ededed;
    position: relative;

    > div.itemBoxIndicators {
      p {
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: 0.01px;
        text-align: left;
        color: #235f6e;
        display: inline-block;
        ${'' /* padding-top: 8px; */}
      }
      span {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: 0.01px;
        text-align: left;
        color: #727272;
        display: inline-block;
        padding-top: 8px;
      }
      margin-top: 1rem;
      padding-top: 1rem;
      &:not(:first-child) {
        border-top: 1px solid #ddd;
      }
    }
  `}
`;

export const BoxIndicatorsTitle = styled.div`
  ${() => css`
    padding-top: 20px;
    p {
      font-size: 0.8rem;
      color: #727272;
      font-weight: 600;
    }
  `}
`;

export const SwitchButton = styled.div`
  ${({ isActive }) => css`
    > b {
      font-weight: 400;
      color: ${isActive ? '#74a50a' : '#727272'};
    }
    .ant-switch {
      min-width: 53px;
      height: 26px;
      line-height: 23px;
      margin-right: 10px;
    }
    .ant-switch-checked {
      background-color: #74a50a;
    }

    .ant-switch-loading-icon,
    .ant-switch::after {
      width: 22px;
      height: 22px;
    }
    &::selection {
      color: #fff;
      background: #74a50a;
    }
    span {
      color: #74a50a;
      font-size: 13px;
    }
  `}
`;

export const BoxStratifications = styled.div`
  ${() => css`
    margin-top: 20px;
    padding: 0 10px;

    div.stratItem {
      padding-bottom: 8px;
      margin-bottom: 8px;
      border-bottom: 1px solid #ddd;
    }
    div.stratItem:last-child {
      border-bottom: none;
    }

    div.stratDates {
      padding-left: 20px;
    }

    div.switchAndTolltip {
      padding-left: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;

      svg {
        color: #74a50a;
        margin-right: 8px;
      }
    }

    div.spaceTooltip {
      width: 15px;
      margin-right: 8px;
    }
  `}
`;
